import type { Subcategory } from '~/entities/categories'
import { getPossibleReasons } from './get-possible-reasons'
import { getSatisfyingCategory } from './get-satisfying-category'

export function getSatisfyingCategoryWithOutcomePreservation({
  currentPhase,
  newOutcome,
  currentReason,
  subcategories,
}: {
  currentPhase: string
  newOutcome?: string
  currentReason?: string
  subcategories: Subcategory[]
}) {
  const possibleReasons = getPossibleReasons({
    phase: currentPhase,
    outcome: newOutcome,
    subcategories,
  })
  // Only carry the reason over when it is still selectable under the new outcome.
  const preservedReason =
    currentReason &&
    possibleReasons.some((reason) => reason.label === currentReason && !reason.isDeprecated)
      ? currentReason
      : undefined

  return getSatisfyingCategory({
    phase: currentPhase,
    outcome: newOutcome,
    reason: preservedReason,
    subcategories,
  })
}
